  import React from 'react';
import BreadCrumbNav from './BreadCrumbNav';
import Footer from './Footer';
import MainHeader from './MainHeader';
import MobileMenu from './MobileMenu';
import ScrollToTopButton from './ScrollToTopButton';
import SearchPopup from './SearchPopup';
import EyeDiseasesContent from './EyeDiseasesContent';
import PreLoader from './PreLoader';

const EyeDiseases = () => {

  return (
    <div className="boxed_wrapper">
        {/* <PreLoader /> */}
        <SearchPopup />
        <MainHeader />
        <MobileMenu />
        <BreadCrumbNav title="Eye Deseases" />

        <EyeDiseasesContent /> 

        <Footer />
        <ScrollToTopButton />
    </div>
    );
  }
  
  export default EyeDiseases;